import React, { useState, useEffect } from 'react';
import { utils, writeFile } from 'xlsx';
import {
  InvestContainer,
  InvestWrapper,
  InvestCard,
  InvestH4,
  InvestH3,
  InvestH2,
  InvestH1,
  FormButton,
  TableWrapper,
} from '../InvestElements';
import Table from 'react-bootstrap/Table';
import '../../../../style.css';

const HasilInvestasi = ({ hasilInvestasi, data }) => {
  const [isMobile, setIsMobile] = useState(false);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR'
    }).format(amount);
  };

  const exportToExcel = () => {
    // Mapping data with custom header names
    const mappedData = data.map(row => ({
      'Bulan': row.bulan,
      'Dana': row.saldo,
      'Pengembangan': row.pengembangan,
      'Biaya': row.biaya,
      'Penarikan Bulanan': row.penarikanBulanan,
      'Saldo Akhir': row.saldoAkhir,
      'Tarif Pajak': row.tarifPajak,
      'Pajak': row.pajak,
      'Dana Diterima': row.penarikanBersih
    }));

    const ws = utils.json_to_sheet(mappedData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Hasil Investasi");
    writeFile(wb, "Hasil_Investasi.xlsx");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check on component mount

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <InvestContainer id="result">
      <InvestH1><b>Hasil Simulasi*</b></InvestH1>
      <InvestH2>*) Hasil simulasi merupakan estimasi, hasil akhir sebenarnya dapat berbeda.</InvestH2>
      {isMobile && (
        <FormButton onClick={exportToExcel}>Rincian Hasil Simulasi</FormButton>
      )}
      <InvestWrapper>
        <InvestCard>
          <InvestH2>Pengambilan Manfaat Sekaligus</InvestH2>
          <InvestH3><b>{formatCurrency(hasilInvestasi.totalDana - hasilInvestasi.pajakSekaligus)}</b></InvestH3>
          <InvestH4><i>Manfaat yang diterima yaitu total dana manfaat dikurangi dengan pajak. Sesuai regulasi, tarif pajak sebesar 5% jika total dana manfaat di atas Rp50.000.000.</i></InvestH4>
        </InvestCard>
        <InvestCard>
          <InvestH2>Pengambilan Manfaat Berkala</InvestH2>
          <InvestH3><b>{formatCurrency(parseFloat(hasilInvestasi.totalDana) + parseFloat(hasilInvestasi.pengembangan) - parseFloat(hasilInvestasi.biaya) - parseFloat(hasilInvestasi.pajakBerkala))}</b></InvestH3>
          <InvestH4><i>Manfaat yang diterima yaitu total dana manfaat ditambah dengan total hasil pengembangan dikurangi dengan biaya administrasi dan juga pajak.</i></InvestH4>
        </InvestCard>
        <InvestCard>
          <InvestH2>Selisih Manfaat</InvestH2>
          <InvestH3><b>{formatCurrency((parseFloat(hasilInvestasi.totalDana) + parseFloat(hasilInvestasi.pengembangan) - parseFloat(hasilInvestasi.biaya) - parseFloat(hasilInvestasi.pajakBerkala)) - (hasilInvestasi.totalDana - hasilInvestasi.pajakSekaligus))}</b></InvestH3>
          <InvestH4><i>Manfaat yang diterima dari pengambilan manfaat berkala lebih besar dibanding manfaat yang diterima dari pengambilan manfaat sekaligus.</i></InvestH4>
        </InvestCard>
      </InvestWrapper>
      {!isMobile && (
        <>
          <FormButton onClick={exportToExcel}>Rincian Hasil Simulasi</FormButton>
          <TableWrapper>
            <Table striped bordered hover className="simulasi">
              <thead>
                <tr>
                  <th>Bulan</th>
                  <th>Dana</th>
                  <th>Pengembangan</th>
                  <th>Biaya</th>
                  <th>DPB</th>
                  <th>Penarikan Bulanan</th>
                  <th>Saldo</th>
                  <th>Tarif Pajak</th>
                  <th>Pajak</th>
                  <th>Dana Diterima</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>{row.bulan}</td>
                    <td>{formatCurrency(row.saldo)}</td>
                    <td>{formatCurrency(row.pengembangan)}</td>
                    <td>{formatCurrency(row.biaya)}</td>
                    <td>{formatCurrency(row.dpb)}</td>
                    <td>{formatCurrency(row.penarikanBulanan)}</td>
                    <td>{formatCurrency(row.saldoAkhir)}</td>
                    <td>{(row.tarifPajak)}%</td>
                    <td>{formatCurrency(row.pajak)}</td>
                    <td>{formatCurrency(row.penarikanBersih)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableWrapper>
        </>
      )}
    </InvestContainer>
  );
};

export default HasilInvestasi;
